import { isPaveRegisted } from '../containers/PagesAndMenus';
import {request} from '../containers/actions';


export const SET_CONTENT = 'CONTENT_MANAGER_SET_CONTENT';
export const SET_URI = 'CONTENT_MANAGER_SET_URI';
export const SET_ERRORS = 'CONTENT_SET_ERRORS';

export function setURI(uri, elementId) {
    return async dispatch => {
        dispatch({
            type: SET_URI,
            elementId,
            uri,
        });

        if(isPaveRegisted(uri)){
            //Do not get page content from server
            var response2 = {
                "id": null,
                "uri": uri,
                "title": "",
                "content": "",
                "readonly": true,
                "published": true,
                "application": null,
                "order": null
            }

            dispatch(setContent(response2, elementId));
            return response2;
        }
        
        
        
        
        const response = await dispatch(request({
            path: '/content/get/',
            body: {uri},
        }));
        if (response.error)
            dispatch(setContent('ERROR!!!', elementId));
        else
            dispatch(setContent(response, elementId));
        return response;
    };
};

export function setContent(content, elementId) {
    return {
        type: SET_CONTENT,
        elementId,
        content,
    };
};

export function save(content, elementId) {
    return async dispatch => {
        const response = await dispatch(request(content.id
            ? {
                path: `/content/${content.id}/`,
                body: content,
                method: 'PATCH',
            }
            : {
                path: '/content/',
                body: content,
                method: 'POST',
            },
        ));
        if (response.error)
            dispatch(setContent('ERROR!!!', elementId));
        else
            dispatch(setContent(response, elementId));
    };
};

export function setErrors(errors, elementId) {
    return {
        type: SET_ERRORS,
        elementId,
        errors,
    };
};
